import React from 'react';
import { getDocs } from 'firebase/firestore';
import { DEFAULT_PROFILE_IMAGE, getQuery } from 'services';
import { Checkbox, FlexContainer, Image, InputStyled, Text } from 'shared/Typhography';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { Button, Splash } from 'shared/Components';

interface SelectUsersModalProps {
  selectedArtists?: string[];
  setArtists: (value: string[]) => void;
  close?: () => void;
}

interface Artist {
  readonly profileImage: string;
  readonly id: string;
  readonly name: string;
  readonly index: number;
}

const ModalWrapper = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: white;
  padding: 32px;
  box-sizing: border-box;
`;

export default function SelectUsersModal({
  close,
  selectedArtists,
  setArtists,
}: SelectUsersModalProps) {
  const [artistOptions, setArtistOptions] = React.useState<Artist[]>();
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const [localSelectedArtists, setLocalSelectedArtists] = React.useState<string[]>(
    selectedArtists ?? [],
  );
  const [state, setState] = React.useState<{ sortBySelected: boolean; search: string }>({
    sortBySelected: false,
    search: '',
  });

  const loadArtistOptions = async () => {
    setLoading(true);
    try {
      const artistQuery = getQuery(
        'usersWeb',
        [{ value: 'artist', operator: '==', attribute: 'Role' }],
        [],
      );
      const artistDocs = await getDocs(artistQuery);
      setArtistOptions(
        artistDocs.docs.map((doc, index) => ({
          profileImage: doc?.data()?.profileImageUrl ?? DEFAULT_PROFILE_IMAGE,
          id: doc.id,
          name: doc?.data()?.name ?? doc?.data()?.Name ?? '-',
          index: index,
        })),
      );
    } catch (err) {
      console.log(err);
      toast.error('Faild to fetch artists!');
    }
    setLoading(false);
  };

  React.useEffect(() => {
    setArtists(localSelectedArtists);
  }, [localSelectedArtists]);

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';

    loadArtistOptions();

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <ModalWrapper>
      <FlexContainer
        flexDirection="column"
        width="100%"
        alignItems="center"
        gap="10px"
        padding="16px"
        style={{ position: 'sticky', top: 0, left: 0, background: 'white' }}
      >
        <FlexContainer flexDirection="row" width="100%" justifyContent="space-between">
          <Text size={1.2} weight="bold">
            Select Artists ({localSelectedArtists?.length})
          </Text>
          <span onClick={close} style={{ fontSize: '32px', cursor: 'pointer' }}>
            X
          </span>
        </FlexContainer>
        <FlexContainer flexDirection="row" width="100%" gap="20px" alignItems="center">
          <div
            style={{
              width: '100%',
              maxWidth: '500px',
              minWidth: '300px',
            }}
          >
            <Text style={{ marginBottom: '10px' }}>Sort by selected first</Text>
            <InputStyled
              type="text"
              onChange={(event) => setState({ ...state, search: event.target.value })}
              value={state.search}
              placeholder="Search by name..."
              style={{
                border: 'solid 1px lightgrey',
                width: '100%',
                height: '50px',
                borderRadius: '80px',
                fontSize: '16px',
              }}
            />
          </div>

          <div>
            <Text style={{ marginBottom: '10px' }}>Sort by selected first</Text>
            <Checkbox
              type="checkbox"
              style={{ width: '50px', height: '50px', margin: 0 }}
              onChange={(event) => {
                setState({ ...state, sortBySelected: event.target.checked });

                if (event.target.checked) {
                  setArtistOptions(
                    artistOptions?.sort(
                      (artist1, artist2) =>
                        (localSelectedArtists?.includes(artist2?.id) ? 1 : 0) -
                        (localSelectedArtists?.includes(artist1?.id) ? 1 : 0),
                    ),
                  );
                  return;
                }
                setArtistOptions(
                  artistOptions?.sort((artist1, artist2) => artist1.index - artist2.index),
                );
              }}
              checked={state.sortBySelected}
            />
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
            <Button
              style={{ fontSize: '16px', height: '50px' }}
              onClick={() =>
                setLocalSelectedArtists((artistOptions ?? [])?.map((item) => item?.id))
              }
            >
              Select All
            </Button>
            <Button
              style={{ fontSize: '16px', height: '50px' }}
              onClick={() => setLocalSelectedArtists([])}
            >
              Clear
            </Button>
          </div>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer flexDirection="column" flex="1">
        {!isLoading &&
          artistOptions?.map((item) => {
            if (!item.name.includes(state.search)) return;
            return (
              <FlexContainer
                padding="4px"
                key={item.id}
                width="100%"
                gap="10px"
                alignItems="center"
                onClick={() =>
                  setLocalSelectedArtists(
                    localSelectedArtists?.includes(item.id)
                      ? localSelectedArtists.filter((tItem) => tItem != item.id)
                      : [...localSelectedArtists, item.id],
                  )
                }
                style={{
                  cursor: 'pointer',
                  background: localSelectedArtists?.includes(item.id) ? '#585CEA' : 'white',
                  color: localSelectedArtists?.includes(item.id) ? 'white' : 'black',
                }}
              >
                <Image
                  maxWidth="64px"
                  maxHeight="64px"
                  src={item.profileImage}
                  borderRadiusType="circle"
                />
                <div style={{ flex: 1 }}>{item.name}</div>
              </FlexContainer>
            );
          })}
        {isLoading && <Splash />}
      </FlexContainer>
    </ModalWrapper>
  );
}
/* 
<FlexContainer maxWidth="200px" width="100%" gap="10px" alignItems="center">
              <Image
                maxWidth="32px"
                maxHeight="100%"
                src={doc?.data()?.profileImageUrl ?? DEFAULT_PROFILE_IMAGE}
                borderRadiusType="circle"
              />
              <div style={{ flex: 1 }}>{doc?.data()?.name ?? doc?.data()?.Name ?? '-'}</div>
            </FlexContainer> */
